import React, { memo } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

import { useMainContainerQuery } from '../../../hooks';
import MobileView from './MobileView';
import LargerView from './LargerView';

const PersonalizedModule = (props) => {

    const {
        players,
        teamId,
        teamName,
        teamLink,
        teamLogoImageTemplateUrl,
        backgroundImageTemplateUrl,
        overlayStyles,
        playerImageTemplateUrl,
        loading,
        onItemClick,
        onAfterChange,
    } = props;

    const isPlayersBelowTeam = useMainContainerQuery(
        ['MD'],
        [false],
        true
    );

    const Component = isPlayersBelowTeam ? MobileView : LargerView;
    return (
        <Component
            teamId={teamId}
            teamName={teamName}
            teamLink={teamLink}
            teamLogoImageTemplateUrl={teamLogoImageTemplateUrl}
            backgroundImageTemplateUrl={backgroundImageTemplateUrl}
            overlayStyles={overlayStyles}
            playerImageTemplateUrl={playerImageTemplateUrl}
            loading={loading}
            players={players}
            onItemClick={onItemClick}
            onAfterChange={onAfterChange}
        />
    );

};

PersonalizedModule.propTypes = {
    teamId: PropTypes.number,
    teamName: PropTypes.string,
    teamLink: PropTypes.string,
    teamLogoImageTemplateUrl: PropTypes.string,
    backgroundImageTemplateUrl: PropTypes.string,
    overlayStyles: PropTypes.string,
    playerImageTemplateUrl: PropTypes.string,
    players: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]),
            lastName: PropTypes.string,
            name: PropTypes.string,
            to: PropTypes.string,
            as: PropTypes.string,
            href: PropTypes.string,
        }),
    ),
    loading: PropTypes.bool,
    onItemClick: PropTypes.func,
    onAfterChange: PropTypes.func,
};

PersonalizedModule.defaultProps = {
    loading: false,
    onItemClick: _noop,
    onAfterChange: _noop,
};

export default memo(PersonalizedModule);
